import { onMounted, onBeforeUnmount, reactive, provide } from 'vue'

/**
 * Composable that provides the methods used by the useMediaQuery composable.
 * Warning: Even though this composable works it SSR, it does not prevent
 * hydration mismatches. Use css responsivity to guarantee that the initial
 * html is the same for every device and do not use components that has different
 * DOM structure.
 */
export default () => {
  const breakPoint = {
    xsMobileMedia: null,
    mobileMedia: null,
    tabletMedia: null
  }

  const mediaQuery = reactive({
    isXsMobile: false,
    isMobile: true,
    isTablet: false
  })

  const refreshBreakPoint = () => {
    mediaQuery.isXsMobile = breakPoint.xsMobileMedia?.matches ?? false
    mediaQuery.isMobile = breakPoint.mobileMedia?.matches ?? true
    mediaQuery.isTablet = breakPoint.tabletMedia?.matches ?? false
  }

  provide('getIsXsMobile', () => {
    return mediaQuery.isXsMobile
  })

  provide('getIsMobile', () => {
    return mediaQuery.isMobile
  })

  provide('getIsTablet', () => {
    return mediaQuery.isTablet
  })

  provide('getIsSafari', () => {
    // TODO
    return false
  })

  provide('getIsIOS', () => {
    // TODO
    return false
  })

  onMounted(() => {
    breakPoint.xsMobileMedia = window.matchMedia('(max-width: 576px)')
    breakPoint.mobileMedia = window.matchMedia('(max-width: 1023px)')
    breakPoint.tabletMedia = window.matchMedia('(max-width: 1279px)')

    refreshBreakPoint()

    window.addEventListener('resize', refreshBreakPoint)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', refreshBreakPoint)
  })
}
